import makeStateFilter from '../../../make-state-filter';

import { stateFilter as parentStateFilter } from '../shipments.reducer.metadata';

const namespace = 'nav';
const stateFilter = makeStateFilter(parentStateFilter, namespace);

export { namespace, stateFilter };
